var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignalStrengthOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6029 0.333984C44.1275 0.333984 46.1654 2.3719 46.1654 4.89648V44.4382C46.1654 46.9627 44.1275 49.0007 41.6029 49.0007C39.0783 49.0007 37.0404 46.9627 37.0404 44.4382V4.89648C37.0404 2.3719 39.0783 0.333984 41.6029 0.333984ZM5.10291 30.7507C7.62749 30.7507 9.66541 32.7886 9.66541 35.3132V44.4382C9.66541 46.9627 7.62749 49.0007 5.10291 49.0007C2.57832 49.0007 0.540405 46.9627 0.540405 44.4382V35.3132C0.540405 32.7886 2.57832 30.7507 5.10291 30.7507ZM23.3529 15.5423C25.8775 15.5423 27.9154 17.5802 27.9154 20.1048V44.4382C27.9154 46.9627 25.8775 49.0007 23.3529 49.0007C20.8283 49.0007 18.7904 46.9627 18.7904 44.4382V20.1048C18.7904 17.5802 20.8283 15.5423 23.3529 15.5423Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalStrengthOrange);
export default __webpack_public_path__ + "static/media/Signal_Strength_Orange.1de2d5526da3eec5a6d7e3de3cbbdc04.svg";
export { ForwardRef as ReactComponent };